module.exports = __webpack_public_path__ + "media/images/people/girl-10-e8cb66b2966205af914a170ab21d0849.webp";